import { render, staticRenderFns } from "./OfferEvaluationPageIndex.vue?vue&type=template&id=42717054&"
import script from "./OfferEvaluationPageIndex.vue?vue&type=script&lang=ts&"
export * from "./OfferEvaluationPageIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42717054')) {
      api.createRecord('42717054', component.options)
    } else {
      api.reload('42717054', component.options)
    }
    module.hot.accept("./OfferEvaluationPageIndex.vue?vue&type=template&id=42717054&", function () {
      api.rerender('42717054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/OfferEvaluationPageIndex.vue"
export default component.exports